<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M22.2 2.3C21.8 1.9 21.2 1.8 20.7 2L2.5 9.3C1.9 9.5 1.5 10 1.5 10.6C1.5 11.2 1.9 11.8 2.5 12L7.8 13.9L16.2 6.8L10.3 14.8V20C10.3 20.6 10.7 21.1 11.3 21.3C11.5 21.4 11.7 21.4 11.9 21.4C12.3 21.4 12.7 21.2 13 20.9L16.2 17.5L19.7 20.2C20.1 20.5 20.6 20.6 21.1 20.4C21.6 20.2 21.9 19.8 22 19.3L23 3.8C23.1 3.2 22.8 2.7 22.2 2.3Z" fill="currentColor"/>
    <path v-else d="M22.2 2.3C21.8 1.9 21.2 1.8 20.7 2L2.5 9.3C1.9 9.5 1.5 10 1.5 10.6C1.5 11.2 1.9 11.8 2.5 12L7.8 13.9L16.2 6.8L10.3 14.8V20C10.3 20.6 10.7 21.1 11.3 21.3C11.5 21.4 11.7 21.4 11.9 21.4C12.3 21.4 12.7 21.2 13 20.9L16.2 17.5L19.7 20.2C20.1 20.5 20.6 20.6 21.1 20.4C21.6 20.2 21.9 19.8 22 19.3L23 3.8C23.1 3.2 22.8 2.7 22.2 2.3ZM18.8 18.2L14.7 15L19.2 8.9L9.3 14.4L4.2 12.6L19.9 4.3L18.8 18.2Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconMessages",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
